type IncidentTeamFields = {
  participant_team_id?: number | null
  participant_id?: number | null
}

export function resolveIncidentTeamId(
  incident: IncidentTeamFields,
): number | null | undefined {
  return incident.participant_team_id ?? incident.participant_id
}
